import { HandoverIcon } from "@/components/icons";

import styles from "./Stages.module.css";

/** The whole sentence — the hover, and what a screen reader hears. */
function handoverSentence(toName: string): string {
  return `Übergabe an ${toName} angefragt`;
}

/**
 * „Übergabe angefragt" as a mark beside the stage chip (register fix round
 * 4, I4): an arrow reaching a person, who it went to in the title.
 *
 * Since UX gate round 1 (#7) the register also writes the word under the
 * chip wherever that line is free — a state in `title` alone reaches
 * neither a finger nor the keyboard. There the word speaks, so the mark is
 * `decorative`: hidden from the screen reader, or the sentence would be
 * heard twice. Where the release („freigegeben mit n Lücken", D-24) holds
 * that line, the mark stays the only sign and says the sentence itself.
 */
export function HandoverMark({ toName, decorative = false }: { toName: string; decorative?: boolean }) {
  const sentence = handoverSentence(toName);
  return (
    <span className={styles.handoverMark} title={sentence} aria-hidden={decorative || undefined}>
      <HandoverIcon size={14} />
      {decorative ? null : <span className="visually-hidden">{sentence}</span>}
    </span>
  );
}

/**
 * The word under the chip (UX gate round 1, #7): „Übergabe angefragt", as
 * on the start page, readable without a hover. The screen reader hears the
 * whole sentence with the name instead of the short word.
 */
export function HandoverWord({ toName }: { toName: string }) {
  const sentence = handoverSentence(toName);
  return (
    <span title={sentence}>
      <span aria-hidden="true">Übergabe angefragt</span>
      <span className="visually-hidden">{sentence}</span>
    </span>
  );
}
